import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cortanctdetail",
  "use": "icon-cortanctdetail-usage",
  "viewBox": "0 0 15 16",
  "content": "<symbol viewBox=\"0 0 15 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cortanctdetail\">\r\n<path d=\"M5.83125 9.6V7.67059C4.35937 7.04941 3.32812 5.63765 3.32812 4C3.3375 1.78824 5.20312 0 7.5 0C9.79688 0 11.6625 1.79765 11.6625 4C11.6625 5.63765 10.6313 7.04941 9.15938 7.67059V9.6H12.9094C14.0625 9.6 15 10.4847 15 11.6047V13.6H0V11.5953C0 10.4941 0.9375 9.6 2.08125 9.6H5.83125ZM0.834375 14.4H14.1656V16H0.834375V14.4Z\" fill=\"#FF912C\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol